/*
|--------------------------------------------------------------------------
| State
|--------------------------------------------------------------------------
*/

const state = {
    message: null,
};

/*
|--------------------------------------------------------------------------
| Actions
|--------------------------------------------------------------------------
*/

const actions = {
    setFooterMessage({ commit }, message) {
        commit('setFooterMessage', message);
    },
};

/*
|--------------------------------------------------------------------------
| Mutations
|--------------------------------------------------------------------------
*/

const mutations = {
    setFooterMessage(state, message) {
        state.message = message;
    },
};

/*
|--------------------------------------------------------------------------
| Export
|--------------------------------------------------------------------------
*/

export const footer = {
    namespaced: true,
    actions,
    mutations,
    state,
};
